var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.7779 61.9423L56.4909 53.6549C53.7494 50.9134 49.288 50.9133 46.5462 53.6549L43.2314 56.9698C42.3151 57.886 40.8327 57.886 39.9164 56.9698L23.0295 40.0831C22.1135 39.1669 22.1133 37.6844 23.0295 36.7682L26.3445 33.4534C29.0862 30.7116 29.0862 26.2505 26.3445 23.5089L18.0573 15.2217C15.3158 12.4799 10.8545 12.4799 8.11282 15.2217L4.79798 18.5365C-1.59933 24.9339 -1.59933 35.3433 4.79798 41.7406L38.2592 75.2018C44.6568 81.5994 55.0661 81.5989 61.4632 75.2018L64.7781 71.8869C67.5196 69.145 67.5196 64.6839 64.7779 61.9423Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1521 28.1276C38.8576 28.1276 37.8081 29.1771 37.8081 30.4716C37.8081 31.7661 38.8576 32.8155 40.1521 32.8155C44.0295 32.8155 47.184 35.97 47.184 39.8474C47.184 41.1419 48.2334 42.1914 49.5279 42.1914C50.8224 42.1914 51.8719 41.1419 51.8719 39.8474C51.8719 33.3851 46.6144 28.1276 40.1521 28.1276ZM40.1521 14.0638C38.8576 14.0638 37.8081 15.1133 37.8081 16.4078C37.8081 17.7023 38.8576 18.7517 40.1521 18.7517C51.7842 18.7517 61.2478 28.2153 61.2478 39.8474C61.2478 41.1419 62.2972 42.1914 63.5917 42.1914C64.8862 42.1914 65.9357 41.1419 65.9357 39.8474C65.9357 25.6303 54.3692 14.0638 40.1521 14.0638ZM68.3284 11.6711C60.8023 4.14476 50.7957 0 40.1521 0C38.8576 0 37.8081 1.04947 37.8081 2.34397C37.8081 3.63846 38.8576 4.68793 40.1521 4.68793C59.539 4.68793 75.3116 20.4605 75.3116 39.8474C75.3116 41.1419 76.361 42.1914 77.6555 42.1914C78.95 42.1914 79.9995 41.1419 79.9995 39.8474C79.9995 29.2038 75.8546 19.1972 68.3284 11.6711Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 21.5284,
    y1: 58.471,
    x2: 41.4176,
    y2: 38.5818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF81FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 43.1825,
    y1: 36.817,
    x2: 68.3284,
    y2: 11.6711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF1FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPhone);
export default __webpack_public_path__ + "static/media/picto_phone.13506c09b6c64463ea3ddb2a34d643e8.svg";
export { ForwardRef as ReactComponent };